import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {GameInfo} from '../../../../../services/games/game-info';
import {Button} from '../../../../../basic-ui-components/button/base/button.component';
import {GameDetailsContainerBox} from '../../boxes/game-details-container/game-details-container.box';
import {GameTitleBox} from '../../boxes/game-title/game-title.box';
import {JackpotAmountBox} from '../../boxes/jackpot-amount/jackpot-amount.box';
import {GameJackpotComponent} from '../../../../game-jackpot/game-jackpot.component';

export interface GameDetailsContainerComponentProps {
    gameInfo: GameInfo;
    onOpenRealGame: () => void;
}

@observer
export class GameDetailsContainerComponent extends OrbitComponent<GameDetailsContainerComponentProps> {
    render() {
        return (
            <GameDetailsContainerBox className='cy-game-details-container'>
                <GameTitleBox className="cy-game-title">
                    {this.props.gameInfo.title}
                </GameTitleBox>

                <JackpotAmountBox data-cy="cy-jackpot-amount">
                    <GameJackpotComponent gameType={this.props.gameInfo.gameType}/>
                </JackpotAmountBox>

                <Button
                    className="cy-hit-the-jackpot-button"
                    onClick={this.props.onOpenRealGame}
                    preset="primaryInverted"
                >
                    {this.services.translation.translate('HIT_THE_JACKPOT')}
                </Button>
            </GameDetailsContainerBox>
        );
    }
}